import { FC } from 'react';
import { SMPFlex, SMPText } from '../../../index';

export interface IH2hHeaderDelimiterProps {
  text: string;
  additionalText?: string;
}

export const H2hHeaderDelimiter: FC<IH2hHeaderDelimiterProps> = ({ text, additionalText }) => {
  return (
    <SMPFlex direction='column' align='center' justify='center'>
      <SMPText size='7' weight='700' variant='contrast'>
        {text}
      </SMPText>
      {additionalText && (
        <SMPText size='2' variant='contrast'>
          {additionalText}
        </SMPText>
      )}
    </SMPFlex>
  );
};
